// Functionality

import * as wealthifyModules from './wealthify-modules/_import';
import * as wealthifyTypes from './wealthify-modules/type/_import';

// Classes

import {default as componentBases} from './wealthify-classes/component-bases/_import';
import {default as componentExtensions} from './wealthify-classes/component-extensions/_import';
import * as generalBases from './wealthify-classes/general-bases/_import';
import * as baseWrappers from './wealthify-classes/base-wrappers/_import';

// Pages

import jisaFriendsFamilyContributorPortfolio from '../pages/jisa-friends-family/contributor-portfolio.js';
import jisaFriendsFamilyContributorTimeline from '../pages/jisa-friends-family/contributor-timeline.js';
import jisaFriendsFamilyInviteContributor from '../pages/jisa-friends-family/invite-contributor.js';
import jisaFriendsFamilyPinVerification from '../pages/jisa-friends-family/pin-verification.js';
import jisaFriendsFamilyContributionOptions from '../pages/jisa-friends-family/contribution/your-options.js';
import jisaFriendsFamilyContributionYourDetails from '../pages/jisa-friends-family/contribution/your-details.js';
import jisaFriendsFamilyContributionBankDetails from '../pages/jisa-friends-family/contribution/bank-details.js';
import jisaFriendsFamilyContributionConfirm from '../pages/jisa-friends-family/contribution/confirm.js';
import jisaFriendsFamilyConfirm from '../pages/jisa-friends-family/confirm.js';

import undismissedContributorInviteAnnouncements from '../pages/dashboard/undismissed-contributor-invite-announcements.js';
import undismissedRemovedContributorAnnouncements from '../pages/dashboard/undismissed-removed-contributor-announcements.js';
import closePlanRequested from '../pages/dashboard/close-plan/close-plan-requested.js';

import signatureUpload from '../pages/transfers/signature-upload.js';
import confirmSignature from '../pages/transfers/confirm-signature.js';
import editSignature from '../pages/transfers/edit-signature.js';

// Wealthify object

window['wealthify'] = {
    ...wealthifyModules,
    type: {...wealthifyTypes},

    // TODO: 20/05/24
    // Remove these page scripts individually from the wealthify object
    // as page scripts are added to their respective page templates
    pages: {
        jisaFriendsFamily: {
            contributorPortfolio: jisaFriendsFamilyContributorPortfolio,
            contributorTimeline: jisaFriendsFamilyContributorTimeline,
            inviteContributor: jisaFriendsFamilyInviteContributor,
            pinVerification: jisaFriendsFamilyPinVerification,
            confirm: jisaFriendsFamilyConfirm,
            contribution: {
                yourOptions: jisaFriendsFamilyContributionOptions,
                yourDetails: jisaFriendsFamilyContributionYourDetails,
                bankDetails: jisaFriendsFamilyContributionBankDetails,
                confirm: jisaFriendsFamilyContributionConfirm
            }
        },
        dashboard: {
            undismissedContributorInviteAnnouncements,
            undismissedRemovedContributorAnnouncements,
            closePlanRequested
        },
        transfers: {
            signatureUpload,
            confirmSignature,
            editSignature
        },
    },

    componentBases,
    componentExtensions,
    ...generalBases,
    ...baseWrappers,
    CustomElementBaseClass: componentBases.WebComponent,// TODO: Remove this once all existing component updated to use componentBases.WebComponent
};